import { OccurrenceFormFields } from '@/components/assessments/forms/OccurrenceForm';
import { StudentAssessmentBody } from '@/data/services/studentAssessmentsServices';

type OccurrenceContext = {
  pedagogicalSheetId: number;
  klassId?: number;
  scheduledLessonId?: number;
};

export const occurrenceFieldsToDTO = (
  { description, notificable }: OccurrenceFormFields,
  { pedagogicalSheetId, klassId, scheduledLessonId }: OccurrenceContext,
): StudentAssessmentBody => ({
  ...(klassId !== undefined ? { klassId } : {}),
  pedagogicalSheetId,
  occurrenceAssessment: {
    description,
    notificable,
    ...(klassId !== undefined ? { scheduledLessonId } : {}),
  },
});
